import { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { HYDRA_6PM_DISPLAY_ADS } from 'constants/hydraTests';
import { isDesktop } from 'helpers/ClientUtils';
import { platformVisibility } from 'helpers/apsAdvertisement';
import { isAssigned } from 'actions/ab';
import useMartyContext from 'hooks/useMartyContext';

import css from 'styles/components/common/gamSlot.scss';

export const GamSlot = ({ slot, hydra6pmDisplayAds, className }) => {
  const device = useRef();
  const [shouldShowOnClient, setClientShow] = useState(false);

  const { marketplace } = useMartyContext();
  const { ads: { sourceId } = {} } = marketplace;

  /*
  * Because want SSR and client render to match, the initial `return` will render nothing for both.
  * Once `setClientShow` fires after mount, we render the iFrame, effectively only
  * rendering it on client, without mismatch warnings. Effects only render client side.
  */
  useEffect(() => {
    setClientShow(true);
    device.current = isDesktop(marketplace) ? 'desktop' : 'mobile'; // set `device` after component has been mounted
  },[marketplace]);

  const shouldRenderOnDevice = platformVisibility[device.current]?.includes(slot);

  /*
  * !hydra6pmDisplayAds: not in test
  * !sourceId: marketplace does not contain sourceId
  * !shouldRenderOnDevice: if slot is designed for specific platform
  */

  if (!hydra6pmDisplayAds || !sourceId || !shouldRenderOnDevice) {
    return null;
  }

  return (
    shouldShowOnClient && <div className={cn(css.container, className)} id={slot} />
  );
};

GamSlot.propTypes = {
  slot: PropTypes.string.isRequired
};

export const mapStateToProps = state => ({
  hydra6pmDisplayAds: isAssigned(HYDRA_6PM_DISPLAY_ADS, 1, state)
});

export default connect(mapStateToProps)(GamSlot);
